import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'start',
    component: () => import('@/views/Start.vue')
  },
  {
    path: '/track-recording',
    name: 'track-recording',
    component: () => import('@/views/track-recording/Index.vue')
  },
  {
    path: '/bulk-actions',
    name: 'bulk-actions-legacy',
    redirect: to => ({
      name: 'operations',
      query: { ...to.query, panel: 'bulk-actions' },
      hash: to.hash
    })
  },
  {
    path: '/backup',
    name: 'backup-legacy',
    redirect: to => ({
      name: 'operations',
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/operations-menu',
    name: 'operations-menu',
    component: () => import('@/views/operations-menu/Index.vue')
  },
  {
    path: '/operations',
    name: 'operations',
    component: () => import('@/views/backup/Index.vue')
  },
  {
    path: '/map-hosts',
    name: 'map-hosts-legacy',
    redirect: to => ({
      name: 'operations',
      query: { ...to.query, panel: 'api-key-central' },
      hash: to.hash
    })
  },
  {
    path: '/about-geomover',
    name: 'about-geomover',
    component: () => import('@/views/about/Index.vue')
  },
  {
    path: '/information',
    name: 'information-legacy',
    redirect: to => ({
      name: 'about-geomover',
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/points-of-interest',
    name: 'points-of-interest',
    component: () => import('@/views/poi/Index.vue')
  },
  {
    path: '/route-planning',
    name: 'route-planning',
    component: () => import('@/views/route-planning/Index.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('@/views/services/Index.vue'),
    children: [
      {
        path: 'map-host/:id',
        name: 'map-host',
        component: () => import('@/components/services/ServiceMapHost.vue')
      },
      {
        path: 'weather-host/:id',
        name: 'weather-host',
        component: () => import('@/components/services/ServiceWeatherHost.vue')
      }
    ]
  },
  {
    path: '/track-studio',
    name: 'track-studio',
    component: () => import('@/views/track-studio/Index.vue'),
    children: [
      {
        path: 'display',
        name: 'track-studio-display',
        component: () => import('@/views/track-studio/display/Index.vue'),
        children: [
          {
            path: ':id/3d',
            name: 'track-studio-display-single-3d',
            component: () => import('@/views/track-studio/display/TrackedRoute3D.vue')
          },
          {
            path: ':id',
            name: 'track-studio-display-single',
            component: () => import('@/views/track-studio/display/TrackedRoute.vue')
          }
        ]
      },
      {
        path: 'merge',
        name: 'track-studio-merge',
        component: () => import('@/views/track-studio/merge/Index.vue')
      },
      {
        path: 'edit',
        name: 'track-studio-edit',
        component: () => import('@/views/track-studio/edit/Index.vue'),
        children: [
          {
            path: ':id',
            name: 'track-studio-edit-single',
            component: () => import('@/views/track-studio/display/TrackedRoute.vue')
          }
        ]
      },
      {
        path: 'overlay',
        name: 'track-studio-overlay',
        component: () => import('@/views/track-studio/overlay/Index.vue')
      },
      {
        path: 'compare',
        name: 'track-studio-compare',
        component: () => import('@/views/track-studio/compare/Index.vue')
      },
      {
        path: ':pathMatch(.*)*',
        name: 'track-studio-404',
        component: () => import('@/views/track-studio/NotFound.vue')
      }
    ]
  },
  {
    path: '/upload',
    name: 'upload',
    component: () => import('@/views/upload/Index.vue')
  },
  {
    // Vue Router 4: catch-all route syntax changed
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/404.vue')
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes
});

export default router;
